The upper limit of events to return from the end of the list.

Excess events will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
